module.exports = __webpack_public_path__ + "static/media/searchIconGrey.896c96c4.png";